import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  slot: "tooltip-content",
  class: "tooltip-content"
}

import {NavigationTabAction} from '@/logged/features';
    import {object, string} from 'vue-types';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TootipWrapper',
  props: {
        content: string().isRequired,
        url: object<NavigationTabAction>(),
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  const _component_joy_tooltip_trigger = _resolveComponent("joy-tooltip-trigger")!

  return (_openBlock(), _createBlock(_component_joy_tooltip_trigger, {
    variant: "secondary",
    position: "bottom-end",
    "tooltip-width": "auto"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(__props.url ? 'a' : 'div'), {
        slot: "tooltip-trigger",
        class: "flex",
        href: __props.url?.href,
        target: __props.url?.blank ? '_blank' : null,
        "data-heap": __props.url?.heapId
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["href", "target", "data-heap"])),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(__props.content), 1)
      ])
    ]),
    _: 3
  }))
}
}

})